export default __webpack_public_path__ + "static/media/female-mechanic-holding-spare-parts-car.875a4de6.webp";